import { createPlanTemplates, deletePlanTemplates, getPlanTemplates } from "@services/miningRate";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import useTypedRequest from "@utils/hooks/useTypedRequest";
import { makeNotifs } from "@utils/makeNotifs";
import { useCallback, useState } from "react";

function isWithColor(
  value: any
): value is IPlanTemplate {
  if (Array.isArray(value)) {
    return false;
  }
  return true;
}

export interface IPlanTemplate {
  id: number;
  planId: number;
  times: [string, string][];
  // added 06.11.24
  color: string;
}

export default function usePlanTemplates(
  getColorForPeriods: (period: [string, string][]) => string
) {

  const { onSuccess } = useGlobalNotifs();
  const notifs = makeNotifs();

  const [templates, setTemplates] = useState<IPlanTemplate[]>([]);

  const { request } = useTypedRequest(createPlanTemplates);
  const { request: getTemplates } = useTypedRequest(getPlanTemplates);
  const { request: doDeleteTemplates } = useTypedRequest(deletePlanTemplates);

  const deleteTemplatesByPlanId = useCallback(
    async (planId: number) => {
      const ids = templates
        .filter((item) => item.planId === planId)
        .map((item) => item.id);
      if (ids.length > 0) {
        const result = await doDeleteTemplates(ids);
        if (result && result.Status === "success") {
          onSuccess(notifs.ok.success);
        }
        setTemplates((prev) => {
          return prev.filter((p) => p.planId !== planId);
        });
      }
    },
    [templates]
  );

  const appendTemplates = useCallback(
    async (planId: number, templatePeriods: [string, string][]) => {
      await deleteTemplatesByPlanId(planId); // в случае ошибки будет несколько записей...
      const values = {
        //id: 0,
        planId: planId,
        times: templatePeriods,
        color: getColorForPeriods(templatePeriods),
      } as IPlanTemplate;
      const response = await request(planId, JSON.stringify(values));
      if (
        response &&
        response.Status === "success" &&
        response.Records.length > 0
      ) {
        values.id = response.Records[0].Id;
        setTemplates([
          ...templates.filter((tt) => tt.planId !== planId),
          values,
        ]);
        onSuccess(notifs.ok.success);
      }
    },
    [templates]
  );

  const loadTemplates = useCallback(async () => {
    const response = await getTemplates();
    if (response && response.Status === "success" && response.Records) {
      const values = response.Records.map((item) => {
        let result: IPlanTemplate = {
          id: item.Id,
          planId: item.PlanId,
          times: [],
          color: "#000000",
        };
        let parsed: string[][] | IPlanTemplate;
        try {
          //const meta = item.Meta.replaceAll("&#34;", '"'); // удалить через пару месяцев 06.11.24
          parsed = JSON.parse(item.Meta);
          if (isWithColor(parsed)) {
            result.color = parsed.color;
            result.times = parsed.times;
          } else { // string[][]
            result.times = parsed as [string, string][];
            result.color = getColorForPeriods(result.times);
          }
        } catch (e) { } // ignore
        return result;
      });
      setTemplates(values);
    }
  }, []);

  return {
    templates,
    setTemplates,
    loadTemplates,
    appendTemplates,
    deleteTemplatesByPlanId,
  }
}